import { gql } from '@apollo/client';

const POST_PERSONAL_INFORMATION = gql`
  mutation createCustomer($customerInput: CustomerInput) {
    createCustomer(customerInput: $customerInput) {
      customerId
    }
  }
`;

const GET_CUSTOMER_INFO = gql`
  query customer {
    customer {
      name
      firstSurname
      rut
      phone
      email
      commune
    }
  }
`;

const CALL_ANALYTICS = gql`
  mutation callAnalytics($event: String!) {
    callAnalytics(event: $event)
  }
`;
const customerOperations = {
  GET_CUSTOMER_INFO,
  POST_PERSONAL_INFORMATION,
  CALL_ANALYTICS,
};

export default customerOperations;
